import { observable, action, makeObservable } from 'mobx';
import lunr from 'lunr';
import { ISearchTeam } from 'interfaces/team/ISearchTeam';
import { SessionVerificationApiService } from 'services/data-services/SessionVerificationService';
import { BaseStore } from './BaseStore';

export class TeamStore extends BaseStore {
  private teamIndex: lunr.Index = lunr(() => {});

  private sessionVerifierService: SessionVerificationApiService;

  @observable teams = [] as ISearchTeam[];

  constructor(sessionVerificationService: SessionVerificationApiService) {
    super();
    this.sessionVerifierService = sessionVerificationService;
    makeObservable(this);
  }

  searchTeamsByName = (query: string, filterId?: string): ISearchTeam[] => {
    query = `+${query.trim().split(' ').join('* +')}*`;
    const res = this.teamIndex.search(query);
    if (filterId) {
      return res
        .map((v: lunr.Index.Result) => this.teams.find((t) => t.id === v.ref) as ISearchTeam)
        .filter((item) => {
          return item.id !== filterId;
        });
    }
    return res.map((v: lunr.Index.Result) => this.teams.find((t) => t.id === v.ref) as ISearchTeam);
  };

  @action setTeams = (data: ISearchTeam[]) => {
    this.teams = data;
    this.initializeIndex();
  };

  @action fetchTeams = async () => {
    try {
      await this.fetchData(this.sessionVerifierService.getTeams, this.setTeams);
    } catch (err) {}
  };

  @action fetchTeamsByName = async (keyword: string) => {
    try {
      const teams = await this.sessionVerifierService.getTeamsByName(keyword);
      this.setTeams(teams);
    } catch (err) {}
  };

  getTeamById = (teamId: string) => this.teams.find((t) => t.id === teamId);

  initializeIndex = () => {
    const { teams } = this;
    this.teamIndex = lunr(function () {
      this.pipeline.remove(lunr.stemmer);
      this.pipeline.remove(lunr.stopWordFilter);
      this.field('name');
      this.ref('id');

      teams.forEach((element) => {
        this.add(element);
      });
    });
  };
}
